import { useEffect, useState } from "react";
import axios from "axios";
import { Trophy, Timer, Flame, UtensilsCrossed, XCircle } from "lucide-react";
import { API, money, errorMessage } from "../api";
import { ddmmyyyy } from "./Digest";
import "./digest.css";

const hourLabel = (h) => `${((h + 11) % 12) + 1} ${h < 12 ? "AM" : "PM"}`;
const mins = (m) => (m == null ? "—" : `${Math.round(m)} min`);

function Stat({ icon: Icon, label, value, sub, testid }) {
  return <div className="pd-stat" data-testid={testid}><Icon size={16} /><span>{label}</span><b>{value}</b><small>{sub}</small></div>;
}

export default function PublicDigest({ digestId }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { axios.get(`${API}/public/digest/${digestId}`).then((r) => setD(r.data)).catch((e) => setErr(errorMessage(e))); }, [digestId]);
  if (err) return <div className="pd-shell"><div className="pd-card" data-testid="public-digest-error">{err}</div></div>;
  if (!d) return <div className="pd-shell"><div className="pd-card">Loading…</div></div>;
  const m = d.metrics, t = m.totals;
  return (
    <div className="pd-shell" data-testid="public-digest-page">
      <div className="pd-card">
        <span className="pd-over">FYNDINE · DAILY OWNER DIGEST</span>
        <h1 data-testid="public-digest-branch">{d.branch_name}</h1>
        <p>{d.branch_city ? `${d.branch_city} · ` : ""}{ddmmyyyy(d.date)}</p>
        <div className="pd-totals">
          <div><span>Sales</span><b data-testid="public-digest-sales">{money(t.sales)}</b></div>
          <div><span>Bills</span><b>{t.bills}</b></div>
          <div><span>Avg bill</span><b>{money(t.avg_bill)}</b></div>
        </div>
        <div className="pd-grid">
          <Stat icon={Trophy} label="Top waiter" testid="public-digest-top-waiter" value={m.top_waiter?.name || "—"} sub={m.top_waiter ? `${money(m.top_waiter.sales)} · ${m.top_waiter.tables} tables` : ""} />
          <Stat icon={Flame} label="Peak hour" testid="public-digest-peak" value={m.peak_hour ? `${hourLabel(m.peak_hour.hour)} – ${hourLabel((m.peak_hour.hour + 1) % 24)}` : "—"} sub={m.peak_hour ? `${money(m.peak_hour.sales)} · ${m.peak_hour.bills} bills` : ""} />
          <Stat icon={UtensilsCrossed} label="Best-seller" testid="public-digest-best" value={m.best_seller?.name || "—"} sub={m.best_seller ? `${m.best_seller.qty} sold · ${money(m.best_seller.revenue)}` : ""} />
          <Stat icon={Timer} label="Fastest table" testid="public-digest-fastest" value={m.fastest_table?.table || "—"} sub={m.fastest_table ? `${mins(m.fastest_table.service_mins)} KOT→ready · ${mins(m.fastest_table.turnover_mins)} seated→paid` : ""} />
        </div>
        {m.waiters?.length > 0 && <><h3>Waiters</h3>{m.waiters.map((w) => <div className="pd-row" key={w.name}><span>{w.name}</span><em>{w.tables} tables</em><b>{money(w.sales)}</b></div>)}</>}
        {m.top_items?.length > 0 && <><h3>Top items</h3>{m.top_items.map((i) => <div className="pd-row" key={i.name}><span>{i.name}</span><em>{i.qty} sold</em><b>{money(i.revenue)}</b></div>)}</>}
        {m.cancellations?.count > 0 && <p className="pd-cancel"><XCircle size={13} /> {m.cancellations.count} KOT cancellations/reductions ({m.cancellations.items} items)</p>}
        <footer>Generated by FynDine · VSM Transnational Pvt Ltd</footer>
      </div>
    </div>
  );
}
